import Link from '@@/auto/components/Link';

import { ReactComponent as BuiltOnSureSvg } from './built-on-sure.min.svg';
import classes from './NavBar.module.css';
import { TMenuLink } from './NavMenuList';

export type TFooterLinks = {
  footerLinks: TMenuLink[];
  shouldHideSocialLinks: boolean;
};

function NavFooter({ footerLinks = [], shouldHideSocialLinks }: TFooterLinks) {
  return (
    <div className={classes.menu_footer} data-testid="navBar_footer">
      {!shouldHideSocialLinks && (
        <div className={classes.menu_footer_social}>
          <a
            href="https://www.facebook.com/toggleinsurance"
            className={classes.menu_footer_social_link}
            data-testid="facebook-social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-facebook-f" />
          </a>
          <a
            href="https://www.instagram.com/toggleinsurance"
            className={classes.menu_footer_social_link}
            data-testid="instagram-social-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram" />
          </a>
        </div>
      )}
      <a
        href="https://www.sureapp.com"
        rel="noopener noreferrer"
        className={classes.menu_footer_built_on_sure}
        aria-label="Built on Sure"
      >
        <BuiltOnSureSvg />
      </a>
      {footerLinks && (
        <div className={classes.menu_footer_pages}>
          {footerLinks.map((footerLink) => (
            <Link
              key={footerLink.to}
              className={classes.menu_footer_pages_link}
              to={footerLink.to}
            >
              {footerLink.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default NavFooter;
